
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1100","height":"1100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M84 0v107.3l39.1 59.8c.3.4.4 1 .4 1.4v92.1l53.4 65.3c.4.5.6 1 .6 1.6v266l63.4 70.8c.4.5.6 1 .6 1.7v434h48V638l-67.8-69.3-.7-.7V302l-57.4-64.3-.6-.7v-93.3l-38.6-59.3-.4-.7V0H84zm-5 0v108c0 .5.1 1 .4 1.4l39.1 59.8v92.3c0 .6.2 1.1.6 1.6l53.4 65.3v266.1c0 .6.2 1.2.6 1.7l63.4 70.8v433H0V0h79zm50 0v82.3l38.6 59.3.4.7V235l57.4 64.3.6.7v266l67.8 69.3.7.7v464h48V606.7l-75.6-63.3c-.6-.5-1-1.2-1-1.9V276.1l-63.6-61.3c-.5-.5-.8-1.1-.8-1.8V0H129zm77.5 0v212l63.7 61.2c.5.5.8 1.1.8 1.8v265.3l75.6 63.3c.6.5.9 1.2.9 1.9V1100h48V576.7l-80.4-62.2c-.7-.5-1-1.2-1-2v-266l-50-54.8c-.4-.5-.6-1-.6-1.7V59.8a10 10 0 115-.3V189l50 54.8c.4.5.6 1 .6 1.7v265.8l80.4 62.2c.6.5 1 1.2 1 2V1100h49V544.2l-77-58.6a10 10 0 112.9-4l78.1 59.4c.6.5 1 1.2 1 2v557H712V483.5c0-.7.3-1.3.8-1.8l84.2-80.8V147.7a10 10 0 115 0V402c0 .7-.3 1.3-.8 1.8L717 484.6V1100h48.5V500.5c0-.7.3-1.4.8-1.8l89.7-82.3V0H206.5zM861 0v417.5c0 .7-.3 1.4-.8 1.8l-89.7 82.3V1100h49V515c0-.7.3-1.4.9-1.9l94.6-81.2V172.5c0-.6.2-1.2.6-1.6l47.9-56.3V0H861zm107.5 0v115.5c0 .6-.2 1.2-.6 1.6L920 173.4V433c0 .7-.3 1.4-.9 1.9l-94.6 81.2V1100h49V530c0-.7.3-1.4.8-1.8l89.7-82.3V187c0-.7.3-1.3.7-1.8l55.8-55.7V0h-52zm57 0v130.5c0 .7-.3 1.3-.7 1.8L969 188v259c0 .7-.3 1.4-.8 1.8l-89.7 82.3V1100h49V575.7a10 10 0 115 0V1100H1100V0h-74.5zm-760 57a7 7 0 100-14 7 7 0 000 14zM366 485a7 7 0 100-14 7 7 0 000 14zm564 88a7 7 0 100-14 7 7 0 000 14zM799.5 145a7 7 0 100-14 7 7 0 000 14z","fill":"#151010"}})])
          )
        }
      }
    